import getMeta from '@jira/platform__utils-get-meta/src/utils/get-meta/index.tsx';
import transformSubProducts from '../transform-sub-products/index.tsx';

const getApplicationSubProduct = (): string => transformSubProducts(getMeta('ajs-application-key'));

export default getApplicationSubProduct;
